export default __webpack_public_path__ + "static/media/button talkback-2.5bc361c4.png";